<template>
  <v-chip v-if="style" :color="style.color" size="small" variant="tonal" label :prepend-icon="style.icon">
    {{ style.label }}
  </v-chip>
  <span v-else class="text-medium-emphasis">—</span>
</template>

<script>
/**
 * ป้าย "ช่องทางโซเชียล" ของเคส — LINE / Facebook / Instagram
 *
 * ⚠️ คนละเรื่องกับ QaChannelChip · ตัวนั้นบอก **ประเภทงาน** (สายสนทนา / แชท)
 *    ตัวนี้บอกว่าแชทนั้นเข้ามาทาง OA ไหน · ทุกเคสที่ระบบเก็บได้ตอนนี้เป็น "แชท" ทั้งหมด
 *    ถ้าเอาสองอย่างมารวมคอลัมน์เดียว ช่อง "ประเภท" จะไม่เหลือความหมายเลย
 *
 * ข้อมูลจำลองไม่มีช่องทางโซเชียล (มีแต่ voice/chat) จึงแสดง "—" ไปตามจริง
 */
const STYLES = {
  line: { color: 'green', icon: 'mdi-chat', label: 'LINE' },
  facebook: { color: 'blue', icon: 'mdi-facebook', label: 'Facebook' },
  instagram: { color: 'pink', icon: 'mdi-instagram', label: 'Instagram' },
};

export default {
  name: 'QaSocialChip',
  props: {
    channelId: { type: String, default: '' },
  },
  computed: {
    style() {
      if (!this.channelId) return null;
      const found = STYLES[String(this.channelId).toLowerCase()];
      // ช่องทางที่ยังไม่รู้จัก (เพิ่ม OA ชนิดใหม่ทีหลัง) — โชว์ชื่อดิบไว้ ดีกว่าซ่อนจนไม่รู้ว่ามี
      return found || { color: 'grey', icon: 'mdi-web', label: this.channelId };
    },
  },
};
</script>
